<div *transloco="let t" class="flex flex-col gap-4 text-gray-800">
  <div class="font-medium">{{ message() }}</div>
  <div>
    <div class="mb-2 font-medium">{{ t("strategy-page.impacted_strategies") }}</div>
    <app-strategy-list-preview [strategies]="impactedStrats()" />
  </div>
  <div class="mt-8 flex justify-end">
    <button iButton variant="ghost" size="md" class="mr-2" (click)="close()">{{ t("common.cancel") }}</button>
    <button iButton variant="destructive" size="md" testId="btn-confirm" (click)="confirm()">
      {{ t("common.confirm") }}
    </button>
  </div>
</div>
